'use client';

import { useLanguage } from '../contexts/LanguageContext';
import content from '../constants/content.json';

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key) => {
    const keys = key.split('.');
    let result = content[language];
    
    for (const k of keys) {
      result = result?.[k];
    }
    
    return result || key;
  };

  return { t, language };
};
